<div class="card">
  <app-grid-server-side
    pageTitle="Outgoing SMS Messages"
    storageKey="outgoing-sms-messages"
    [maxBlocksInCache]="1"
    [excelStyles]="excelStyles"
    [defaultExcelExportParams]="excelExportParams"
    [colDefs]="$any(colDefs())"
    [rowData]="[]"
    [totalRows]="totalRows()"
    [gridOptions]="gridOptions"
    [suppressRowClickSelection]="true"
    [serverSideDatasource]="dataSource()"
    [paginationPageSize]="defaultPageSize"
    [cacheBlockSize]="cacheBlockSize"
    (gridReady)="onGridReady($event)"
    (select)="selectTextMessageRecord($event)"
    (search)="onSearch($event)"
  >
    <div class="grid-controls-end d-flex justify-content-end gap-12">
      @if (checkedTextMessageRecords.length) {
        <app-button
          title="Export selected messages"
          btnColor="white"
          iconClass="icon ic-download-20"
          [isDisabled]="!totalRows || modalOpened()"
          (clickBtn)="exportSelectedTextMessagesToXls()"
        />
      } @else {
        <app-button
          title="Export"
          btnColor="white"
          iconClass="icon ic-download-20"
          [isDisabled]="!totalRows || modalOpened()"
          (clickBtn)="exportTextMessagesList(false, ExportTypeEnum.EXCEL)"
        />
      }
    </div>
  </app-grid-server-side>
</div>

<app-outgoing-text-message-details
  [isOuterLoading]="isDetailsLoading"
  [opened]="!!$selectedTextMessageRecord()"
  [textMessageRecord]="$selectedTextMessageRecord()"
  [currentEmailMessageIndex]="currentTextMessageRecordIndex"
  [totalRows]="totalRows()"
  [currentEmailMessageItemNumber]="currentTextMessageItemNumber"
  (close)="onCloseDetails()"
  (getNextEmailMessage)="nextTextMessage()"
  (getPreviousEmailMessage)="previousTextMessage()"
  (refreshData)="reloadGrid()"
/>
